import { Typography } from "@mui/material"
import KAProgress from "../../keyword-assist/components/KAProgress"
import BlogGenerationBreadcrumbs from "./BlogGenerationBreadcrumbs"
import BlogGenerationHeader from "./BlogGenerationHeader"
import { keywordResearchDashBoardCss } from "src/content/keywordResearch/keywordResearchCSS"

/**
 * `BGCommon` is a layout/container component that renders the shared layout elements 
 * for the Blog Generation feature interface.
 * 
 * It structures the top-level section of the Blog Generation dashboard, including:
 * 1. Navigation Breadcrumbs (`BlogGenerationBreadcrumbs`) - Displays the location trail.
 * 2. Header Actions (`BlogGenerationHeader`) - Displays controls/actions for Blog Generation.
 * 3. Usage tracking progress visualization (`KAProgress`) - Shows the remaining and used limits for blog generations.
 * 
 * ### Re-used Components:
 * - {@link KAProgress} - Re-used from keyword-assist — generic compound component for progress tracking.
 * 
 * @component
 * @category Component
 * @subcategory BlogGeneration
 * @example
 * ```tsx
 * import BGCommon from './BGCommon';
 * 
 * function BlogGenerationPage() {
 *   return (
 *     <div className="blog-generation-container">
 *       <BGCommon />
 *       <main>Main Content</main>
 *     </div>
 *   );
 * }
 * ```
 * 
 * @returns {JSX.Element} The rendered common top layout and progress tracker section.
 */
function BGCommon() {
  return (
    <>
      <div className="flex justify-between items-center mb-3">
        <BlogGenerationBreadcrumbs />
        <BlogGenerationHeader />
      </div>

      {/* <div aria-label="blog-generation-progress">
        <KAProgress totalLimit={100} totalUsed={0}>
          <div className="mb-1 flex justify-between">
            <KAProgress.Text>
              <KAProgress.Tooltip
                title={
                  <Typography
                    sx={{
                      ...keywordResearchDashBoardCss?.customTollTipText,
                      lineHeight: 'var(--line-height-22)'
                    }}
                  >
                    The maximum number of Blog Generation requests you can run each month under your plan, resetting at the start of each billing cycle.
                  </Typography>
                }
              />
            </KAProgress.Text>
            <KAProgress.Action />
          </div>
          <KAProgress.Bar />
        </KAProgress>
      </div> */}
    </>
  )
}

export default BGCommon;
